<script setup lang="ts">

</script>

<template>
  <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.26709 7.69873L1 4.43164M4.26709 4.43164L7.53418 7.69873L14.0684 1.16455M7.53418 4.43164L10.8013 1.16455" stroke="#DD0935" stroke-width="1.30684" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped lang="scss">

</style>